import { IConfig } from '@qunhe/ktracker-types';
import { DefTypes } from '../constants';
import { getType } from './func';
import logger from './logger';
import SystemOptions from './options';

function sendWithBeacon(data: any, url: string): Promise<any> {
  const payload = getType(data) === DefTypes.OBJECT ? JSON.stringify(data) : data;
  const options: IConfig = SystemOptions.getInstance().getOptions();

  return new Promise((resolve) => {
    const ret = window.navigator.sendBeacon(url, payload);
    if (ret) {
      if (options.debug) {
        logger.info('ajax send[url: ' + url + ', sendBeacon: true]');
      }
      resolve(true);
    } else {
      if (options.debug) {
        logger.error('ajax error[url: ' + url + ', sendBeacon: true]');
      }
      resolve(false);
    }
  });
}

function sendWithXMLHttpRequest(data: any, url: string) {
  const payload = getType(data) === DefTypes.OBJECT ? JSON.stringify(data) : data;
  const options: IConfig = SystemOptions.getInstance().getOptions();

  return new Promise(function (resolve) {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', url);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onload = function () {
      if (this.status >= 200 && this.status < 300) {
        if (options.debug) {
          logger.info('ajax send[url: ' + url + ', sendWithXMLHttpRequest: true]');
        }
        resolve(xhr.response);
      } else {
        if (options.debug) {
          logger.error('ajax error[url: ' + url + ', sendWithXMLHttpRequest: true]');
        }
        resolve({
          status: this.status,
          statusText: xhr.statusText,
        });
      }
    };
    xhr.onerror = function () {
      if (options.debug) {
        logger.error('ajax error[url: ' + url + ', sendWithXMLHttpRequest: true]');
      }
      resolve({
        status: this.status,
        statusText: xhr.statusText,
      });
    };
    xhr.send(payload);
  });
}

async function send(data: any, url: string) {
  if ('sendBeacon' in window.navigator) {
    return sendWithBeacon(data, url);
  } else {
    return sendWithXMLHttpRequest(data, url);
  }
}

export default {
  send,
  sendWithBeacon,
  sendWithXMLHttpRequest,
};
